// extracted by mini-css-extract-plugin
module.exports = {"layout":"YU7iNhGm","starWrapper":"T9nXRR91"};